const KAYA_SHARE_URL = 'https://kaya-app.kayaclimb.com/share';

export function getCompetitionUrl(gym_slug, competition_slug) {
  return `/gym/${gym_slug}/competition/${competition_slug}`;
}

export function getGymUrl(gym_slug, climb_type_id) {
  let result = `/gym/${gym_slug}`;
  if (climb_type_id) {
    result += `/${climb_type_id}`;
  }
  return result;
}

export function getGymFullReportUrl(gym_slug) {
  return `/reports/full`;
}


export function getGymMapUrl(gym_slug) {
  return `/map/${gym_slug}`;
}

export function getGymMapEditUrl(gym_slug) {
  return `/map/${gym_slug}/edit`;
}

export function getGymSettingsUrl(gym_slug, settings) {
  return `/settings/${settings}/${gym_slug}`;
}

export function getLoginUrl() {
  return '/login';
}

export function getUserUrl(user_slug) {
  return `/profile/${user_slug}`;
}

export function getUserSettingsUrl(user_slug) {
  return `/profile/${user_slug}/settings`;
}

export function getWallUrl(gym_slug, wall_slug, wall_set_id, climb_id) {
  let result = `/gym/${gym_slug}/wall/${wall_slug}`;
  if (wall_set_id) {
    result += `/set/${wall_set_id}`;
  }
  if (climb_id) {
    result += `/climb/${climb_id}`;
  }
  return result;
}

export function getWallSettingsUrl(gym_slug, wall_slug) {
  return `/gym/${gym_slug}/wall/${wall_slug}/settings`;
}

export function getWallResetUrl(gym_slug, wall_slug, fromMap) {
  return `/gym/${gym_slug}/wall/${wall_slug}/reset${fromMap ? '/fromMap' : ''}`;
}

export function getChallengeUrl(challenge_id) {
  return `/challenges/view/${challenge_id}`;
}

export function getChallengeEditUrl(challenge_id) {
  return `/challenges/edit/${challenge_id}`;
}

export function getChallengeCreateUrl(gym_slug, template_id, duplicate_challenge_id) {
  if (duplicate_challenge_id) {
    return `/challenges/create/${gym_slug}/${template_id}/${duplicate_challenge_id}`;
  }
  return `/challenges/create/${gym_slug}/${template_id}`;
}

export function getChallengesUrl(gym_slug) {
  return `/challenges/${gym_slug}`;
}

export function getDestinationUrl(destination_id) {
  return `/destination/${destination_id}`;
}

export function getKAYAClimbUrl(climb_id) {
  return `${KAYA_SHARE_URL}/climb?climb_id=${climb_id}`;
}
